import { useState, useEffect } from "react";
import "@/App.css";
import axios from "axios";
import RulesPage from "./components/RulesPage";
import BioForm from "./components/BioForm";
import BettingDashboard from "./components/BettingDashboard";
import SuccessView from "./components/SuccessView";
import AdminPanel from "./components/AdminPanel";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [currentView, setCurrentView] = useState("rules"); // rules, bio, betting, success, admin
  const [userData, setUserData] = useState(null);
  const [betData, setBetData] = useState(null);

  // Check if user already has bets when they provide email
  const checkExistingBet = async (email) => {
    try {
      const response = await axios.get(`${API}/bets/${email}`);
      return response.data;
    } catch (error) {
      // No existing bet found
      return null;
    }
  };

  // Handle admin route
  useEffect(() => {
    if (window.location.pathname === "/admin") {
      setCurrentView("admin");
    }
  }, []);

  const handlePlayClick = () => {
    setCurrentView("bio");
  };

  const handleBioSubmit = async (bioData) => {
    // Check for existing bet
    const existingBet = await checkExistingBet(bioData.email);
    
    setUserData(bioData);
    
    if (existingBet) {
      // Load existing bet data
      setBetData({
        bet1_choice: existingBet.bet1_choice,
        bet1_wager: existingBet.bet1_wager,
        bet2_choice: existingBet.bet2_choice,
        bet2_wager: existingBet.bet2_wager,
        bet3_date: existingBet.bet3_date,
        bet3_wager: existingBet.bet3_wager,
        total_wager: existingBet.total_wager
      });
    }
    
    setCurrentView("betting");
  };

  const handleBetSubmit = async (bets) => {
    setBetData(bets);
    
    // Submit to backend
    try {
      await axios.post(`${API}/bets`, {
        ...userData,
        ...bets
      });
      setCurrentView("success");
    } catch (error) {
      console.error("Error submitting bet:", error);
      alert("Failed to submit bet. Please try again.");
    }
  };

  const handleBackToRules = () => {
    setCurrentView("rules");
    setUserData(null);
    setBetData(null);
  };

  return (
    <div className="App min-h-screen">
      {currentView === "rules" && <RulesPage onPlayClick={handlePlayClick} />}
      {currentView === "bio" && <BioForm onSubmit={handleBioSubmit} />}
      {currentView === "betting" && (
        <BettingDashboard
          userData={userData}
          existingBets={betData}
          onSubmit={handleBetSubmit}
        />
      )}
      {currentView === "success" && (
        <SuccessView betData={betData} onBackToRules={handleBackToRules} />
      )}
      {currentView === "admin" && <AdminPanel apiUrl={API} />}
    </div>
  );
}

export default App;
